import { render, staticRenderFns } from "./DashboardGradient.vue?vue&type=template&id=660a774e"
import script from "./DashboardGradient.vue?vue&type=script&lang=js"
export * from "./DashboardGradient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports